module.exports = __webpack_public_path__ + "img/115.1cbdd0c3.jpg";